import React from 'react';
import { useTheme, ITheme } from 'src/theme';
import { styled } from '@linaria/react';
import { css } from '@linaria/core';
import IconDownload from '@assets/icon/download.svg';

import Icon from '@components/Icon';
import ContainerBlock from '@components/ContainerBlock';
import Text from '@components/Text';
import Link from '@components/Link';
import Heading from '@components/Heading';

const FlexRow = styled.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: 20px;
`
const IconMargin = css`
  margin-right: 24px;
  margin-top: 4px;
`

export interface PlanInformationProps {
  brochureUrl?: string;
}

function PlanInformation({ brochureUrl }: PlanInformationProps) {
  const theme: ITheme = useTheme();
  return (
    <ContainerBlock
      background={theme.colors.grey[200]}
      boxShadow="0 2px 2px 0 rgba(204, 204, 204, 0.5)"
      borderTop={`3px solid ${theme.colors.primary}`}
      padding="25px 20px"
      paddingTablet="25px 30px"
    >
      <Heading variant="smallTitle" fontWeight={600} color={theme.colors.grey[400]} margin="0 0 20px">Singlife CareShield Standard / Singlife CareShield Plus</Heading>
      <Text margin="0 0 20px">Enhance your CareShield Life or ElderShield policy coverage with Singlife CareShield Standard or Singlife CareShield Plus for greater financial assurance.</Text>
      <FlexRow>
        <Icon className={IconMargin} name="confirmation-tick"/>
        <div>
          <Text>
            <strong>Higher monthly payouts for a lifetime</strong><br/>
            On top of your CareShield Life or ElderShield payouts, get additional payouts when you’re severely disabled.
          </Text>
        </div>
      </FlexRow>
      <FlexRow>
        <Icon className={IconMargin} name="confirmation-tick"/>
        <div>
          <Text>
            <strong>Additional support</strong><br/>
            Receive a Lump Sum Benefit, Rehabilitation Benefit (only for Singlife CareShield Standard), Dependant Care Benefit, Caregiver Relief Benefit and/or Death Benefit.
          </Text>
        </div>
      </FlexRow>
      <FlexRow>
        <Icon className={IconMargin} name="confirmation-tick"/>
        <div>
          <Text>
            <strong>Premiums waived when it matters</strong><br/>
            Future premiums are waived for as long as you’re unable to perform at least 1 Activity of Daily Living (ADL).
          </Text>
        </div>
      </FlexRow>
      <Link text="Download brochure" icon={IconDownload} slotIcon="start" download="Brochure" target="_blank" rel="noopener noreferrer" url={brochureUrl} />
    </ContainerBlock>
  );
};

export default PlanInformation;
